/**
 * Version Manager - Detects new app deployments and forces refresh
 * Works with saved URLs and service workers
 */

import { showToast } from "./toastUtils";

let versionCheckInterval = null;

const clearAllCaches = async () => {
  try {
    // Clear local and session storage
    localStorage.clear();
    sessionStorage.clear();

    // Unregister service workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const reg of registrations) {
        await reg.unregister();
      }
    }

    // Clear Cache Storage
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    }

    console.log('All caches cleared');
  } catch (err) {
    console.error('Error clearing caches', err);
  }
};

const showUpdateNotification = () => {
  setTimeout(() => {
              showToast("New version is available..", "success");
  }, 1000);
};

// Fetch server version
const getServerVersion = async () => {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    if (!res.ok) throw new Error('Failed to fetch version.json');
    const data = await res.json();
    return data.version;
  } catch (err) {
    console.error('Error fetching server version', err);
    return null;
  }
};

const checkVersion = async () => {
  const serverVersion = await getServerVersion();
  if (!serverVersion) return;

  const localVersion = localStorage.getItem('appVersion');

  if (!localVersion) {
    localStorage.setItem('appVersion', serverVersion);
  } else if (localVersion !== serverVersion) {
    console.log(`New version detected! Old: ${localVersion}, New: ${serverVersion}`);
    showUpdateNotification();
    await clearAllCaches();
    localStorage.setItem('appVersion', serverVersion);
    setTimeout(() => window.location.reload(), 3000);
    return true;
  }
  return false;
};

export const initVersionCheck = async () => {
  await checkVersion(); // Initial check

  // Periodic check every 5 mins
  if (!versionCheckInterval) {
    versionCheckInterval = setInterval(checkVersion, 5 * 60 * 1000);
  }
};

export const stopVersionCheck = () => {
  if (versionCheckInterval) {
    clearInterval(versionCheckInterval);
    versionCheckInterval = null;
  }
};

export const forceRefresh = async () => {
  await clearAllCaches();
  window.location.reload();
};
